module.exports = __webpack_public_path__ + "img/icon_tg.aeadae09.svg";